import typeUtils from '../../../../utils/type';

export const isVisibleIndicator = (indicator, selectedItems) => {
	if (indicator.isRequired) {
		return true;
	}

	const setting = selectedItems.find((i) => i.id === indicator.id);

	if (setting) {
		return setting.visible && !indicator.isTemporaryHidden;
	}

	return typeUtils.isNullOrUndefined(indicator.isTemporaryHidden) ? indicator.visible : !indicator.isTemporaryHidden;
};
